import React from 'react'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { ICreateDun } from '../../../interfaces/StockKeepingUnitDun/StockKeepingUnitDun'
import { TypePackage } from '../entities/Product'

export type CustomActionsProps = {
  id: number
  row: ICreateDun
}

export const generateTableHeadersProduct = (
  typepackages: TypePackage[] | undefined
) => {
  const tableHeadersProduct: TableHeaderConfigWithType<ICreateDun>[] = [
    {
      field: 'dun',
      title: 'DUN',
      sortable: false
    },
    {
      field: 'quantity',
      title: 'Cantidad',
      sortable: false
    },
    {
      field: 'description',
      title: 'Descripción',
      sortable: false
    },
    {
      field: 'typePackageId',
      title: 'Unidad de Medida',
      sortable: false,
      formater: (value: unknown) =>
        typepackages?.find((el) => el.typePackageId === (value as number))
          ?.name || ''
    },
    {
      field: 'isDefault',
      title: 'Predeterminado',
      sortable: false,
      formater: (active: unknown) => setIconState(active as boolean)
    }
  ]

  return tableHeadersProduct
}

const setIconState = (active: boolean) => {
  let backgroundColor = ''
  let colorText = ''
  let text = ''

  if (active) {
    backgroundColor = '#157715ff'
    colorText = 'white'
    text = 'Sí'
  } else {
    backgroundColor = '#e0e0e0' // Gris similar al de los botones default de Material-UI
    colorText = 'rgba(0, 0, 0, 0.87)' // Color de texto similar al de Material-UI
    text = 'No'
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <div
        style={{
          borderRadius: '20px',
          padding: '4px 12px',
          fontSize: '11px',
          width: '20px',
          backgroundColor: backgroundColor,
          color: colorText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          fontWeight: '500'
        }}
      >
        {text}
      </div>
    </div>
  )
}
